import { render, staticRenderFns } from "./wps.vue?vue&type=template&id=70334e56"
import script from "./wps.vue?vue&type=script&lang=js"
export * from "./wps.vue?vue&type=script&lang=js"
import style0 from "./wps.vue?vue&type=style&index=0&id=70334e56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports